import { VoiceRequestCancellation } from "./voice-request-cancellation";

/** The one-shot dictation request: what that recording's late events answer
 *  to. Its own module so live mode can drop it when it takes over. */
export const dictationRequest = new VoiceRequestCancellation();
